import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-dinings-card',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './dinings-card.component.html',
  styleUrl: './dinings-card.component.scss',
})
export class DiningsCardComponent {
  constructor(private router: Router) {}
  @Input() dinings!: any;

  goToDining(slug?: string) {
    console.log('slug:', slug);
    
    if (!slug) return; // avoid navigating to an invalid route
    this.router.navigate(['/restaurant', slug]);
  }
}
